import store from '../store'

export const  statusColor = (status) => {
  let colorOfStatus
  switch (status) {
    case store.state.statuses.mimkStatuses.working.statusMatch:
    colorOfStatus = '#D1FFD4'
    break;
    case store.state.statuses.mimkStatuses.noWork.statusMatch:
    colorOfStatus = '#E0E0E0'
    break;
    case store.state.statuses.mimkStatuses.readyToTake.statusMatch:
    colorOfStatus = '#D1FFD4'
    break;
    default: 
    colorOfStatus = '#D1FFD4'
  }   
  return colorOfStatus
}

export const statusesMimkForFilter =  [
  {        
    title: store.state.statuses.mimkStatuses.working.title,
    match:  store.state.statuses.mimkStatuses.working.statusMatch,
    translateStatusTitle: 'status.working',
    active: false
  },
  {        
    title: store.state.statuses.mimkStatuses.noWork.title,
    match:  store.state.statuses.mimkStatuses.noWork.statusMatch,
    translateStatusTitle: 'status.nonWorking',
    active: false
  },
  {        
    title: store.state.statuses.mimkStatuses.readyToTake.title,
    match:  store.state.statuses.mimkStatuses.readyToTake.statusMatch,
    translateStatusTitle: 'status.waitingClient',
    active: false
  },
  {        
    title: store.state.statuses.mimkStatuses.doNotStartMc.title,
    match:  store.state.statuses.mimkStatuses.doNotStartMc.statusMatch,
    translateStatusTitle: 'status.notStarted',
    active: false
  },
  {        
    title: store.state.statuses.mimkStatuses.finishedWork.title,
    match:  store.state.statuses.mimkStatuses.finishedWork.statusMatch,
    translateStatusTitle: 'status.finishedWork',
    active: false
  },
  {        
    title: store.state.statuses.mimkStatuses.startenInTheNextSlot.title,
    match:  store.state.statuses.mimkStatuses.startenInTheNextSlot.statusMatch,
    translateStatusTitle: 'status.startenInTheNextSlot',
    active: false
  },
]